<template lang="pug">
.filter-bar
  .filter-bar-row
    slot
    .filter-bar-actions(v-if="$slots.actions")
      slot(name="actions")
</template>

<script>
/**
 * Barra de filtros sobre una tabla.
 *
 * Reemplaza al par de clases sueltas .table-filters-container /
 * .table-filters-row, que solo la mitad de las vistas con tabla usaba
 * (34 de 67): el resto improvisaba su propio layout y la barra cambiaba
 * de alto y de alineación al pasar de una pantalla a otra.
 *
 * Uso:
 *   FilterBar
 *     .filter-item.search-field
 *       InputText(v-model="q" placeholder="Buscar...")
 *     template(#actions)
 *       Button(label="Nuevo cliente")
 */
export default {
  name: 'FilterBar',
};
</script>

<style scoped>
.filter-bar {
  background: var(--escality-surface);
  border: 1px solid var(--escality-gray-200);
  border-radius: var(--escality-radius-lg);
  box-shadow: var(--escality-shadow-sm);
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
}

.filter-bar-row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
}

/* Las acciones se van al extremo opuesto de los filtros. */
.filter-bar-actions {
  flex: 0 0 auto;
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

@media (max-width: 768px) {
  .filter-bar-row {
    flex-direction: column;
    align-items: stretch;
  }

  .filter-bar-actions {
    width: 100%;
    margin-left: 0;
  }

  .filter-bar-actions :deep(.p-button) {
    flex: 1;
  }
}
</style>
